import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import { useI18nTranslation, useLocale } from 'platform-i18n-utils';

import {
  I18N_KEYS,
  PAGE_TITLE,
  LAUNCH_ERROR_MESSAGE,
  LOADING_FORM_MESSAGE,
  LOADING_VERIFYING_SESSION_MESSAGE
} from '../../constants';
import { useTicketBootstrap } from '../../hooks';
import TicketForm from '../ticket-form/ticket-form';
import TicketPageError from './ticket-page-error';
import TicketPageLoading from './ticket-page-loading';

const LOADING_MESSAGES = {
  parsing: { key: I18N_KEYS.LOADING_FORM, defaultValue: LOADING_FORM_MESSAGE },
  redeeming: { key: I18N_KEYS.LOADING_VERIFYING_SESSION, defaultValue: LOADING_VERIFYING_SESSION_MESSAGE },
  loadingConfig: { key: I18N_KEYS.LOADING_FORM, defaultValue: LOADING_FORM_MESSAGE }
};

const TicketPage = () => {
  const { t } = useI18nTranslation();
  const { locale } = useLocale() ?? {};
  const { status, config, eid } = useTicketBootstrap();

  const pageTitle = t(I18N_KEYS.PAGE_TITLE, { defaultValue: PAGE_TITLE });

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  useEffect(() => {
    if (locale) {
      document.documentElement.lang = String(locale).replace('_', '-');
    }
  }, [locale]);

  const renderContent = () => {
    if (status === 'error') {
      return <TicketPageError message={t(I18N_KEYS.LAUNCH_ERROR, { defaultValue: LAUNCH_ERROR_MESSAGE })} />;
    }

    if (status === 'ready' && config && eid) {
      return <TicketForm config={config} eid={eid} />;
    }

    const loading = LOADING_MESSAGES[status] ?? LOADING_MESSAGES.parsing;

    return <TicketPageLoading message={t(loading.key, { defaultValue: loading.defaultValue })} />;
  };

  return (
    <Box data-testid="ticket-page" sx={{ minHeight: '100vh' }}>
      {renderContent()}
    </Box>
  );
};

export default TicketPage;
